/**
 * PolicyView
 * 
 * Shared wrapper component for policy pages.
 * Provides consistent header, footer, and styling.
 */

import { Link } from 'react-router-dom'
import { GlassPanel, Icon } from '../components/common'
import { PublicFooter } from '../components/common/PublicFooter'
import { APP_LOGO_TEXT } from '../config/branding'
import './PolicyView.css'

export function PolicyView({ title, lastUpdated, children }) {
  return (
    <div className="policy-view">
      {/* Background effects */}
      <div className="policy-background">
        <div className="policy-grid" />
        <div className="policy-glow policy-glow-1" />
      </div>

      {/* Header */}
      <header className="policy-header">
        <Link to="/" className="policy-header__logo">
          <Icon name="logo-saturn" size={28} />
          <span>{APP_LOGO_TEXT}</span>
        </Link>
        <nav className="policy-header__nav">
          <Link to="/">Home</Link>
          <Link to="/login" className="policy-header__login">Sign in</Link>
        </nav>
      </header>

      {/* Content */}
      <main className="policy-main">
        <div className="policy-container">
          <GlassPanel padding="xl" className="policy-content">
            <h1 className="policy-title">{title}</h1>
            {lastUpdated && (
              <p className="policy-updated">Last updated: {lastUpdated}</p>
            )}
            <div className="policy-body">
              {children}
            </div>
          </GlassPanel>
        </div>
      </main>

      {/* Footer */}
      <PublicFooter />
    </div>
  )
}

export default PolicyView
